module.exports = __webpack_public_path__ + "media/images/rolllaeden-f04f403446bb90b6aecccea3e9e10da4.jpg";